import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.headers.length ? _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.newColumn,
      callback: function ($$v) {
        _vm.newColumn = $$v;
      },
      expression: "newColumn"
    }
  }, [_c('div', [_c('core-n20Card', {
    attrs: {
      "buttons": _vm.buttons
    },
    on: {
      "apply": _vm.addNewColmn
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mx-0 my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.columnName'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.columnName,
      callback: function ($$v) {
        _vm.columnName = $$v;
      },
      expression: "columnName"
    }
  })], 1)], 1)], 1)], 1)]), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.editDialog,
      callback: function ($$v) {
        _vm.editDialog = $$v;
      },
      expression: "editDialog"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "buttons": _vm.editButtons
    },
    on: {
      "save": _vm.saveItem,
      "close": function ($event) {
        _vm.editDialog = false;
        _vm.editCols = {};
      }
    }
  }, [_c(VCardTitle, {
    staticClass: "px-1"
  }, [_c('h3', {
    class: `my-0 headline ${_vm.color}--text`
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.titleUpdate')) + "\n        ")])]), _c('niota-classic-devices-upload-edit-form', {
    attrs: {
      "editCols": _vm.editCols,
      "applications": _vm.applications,
      "originators": _vm.originators,
      "deviceTypes": _vm.deviceTypes
    },
    on: {
      "update-otaa": _vm.updateOtaa,
      "update-originator-id": _vm.updateOriginatorId
    }
  })], 1)], 1), _c(VCard, {
    staticClass: "px-0 mt-4"
  }, [_c(VCardText, {
    staticClass: "mt-0"
  }, [_c('h5', {
    staticClass: "mb-0 headline-with-icon"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-cogs")]), _vm._v("\n         \n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.defaultSettings')) + "\n      ")], 1), _c(VRow, [_c(VCol, {
    staticClass: "mx-0 my-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-laptop",
      "title": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "offset": 24
    }
  }, [_vm.applications.length ? _c('div', {
    staticClass: "pt-4"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.applications,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.setApplicationId
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "applicationId", $$v);
      },
      expression: "formItem.applicationId"
    }
  })], 1) : _vm._e()])], 1), _vm.originators.length ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-cloud-upload",
      "title": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.originators,
      "filter": _vm.filterItems,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.selcetedOriginator
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.originator,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "originator", $$v);
      },
      expression: "formItem.originator"
    }
  })], 1)])], 1) : _vm._e(), _vm.deviceTypes.length ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-cubes",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.setDeviceType
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "deviceTypeId", $$v);
      },
      expression: "formItem.deviceTypeId"
    }
  })], 1)])], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-cog",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.activationMethod'),
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4 pb-2"
  }, [_c(VSwitch, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "value": true,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.otaaAbp')
    },
    on: {
      "change": _vm.setOtaa
    },
    model: {
      value: _vm.formItem.otaa,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "otaa", $$v);
      },
      expression: "formItem.otaa"
    }
  })], 1)])], 1), _vm.datasourceType === 'actility' ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-industry-alt",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.manufacturerModel'),
      "offset": 24
    }
  }, [!_vm.actilityOptionsIsLoading ? _c('div', {
    staticClass: "pt-4 pb-7"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.manufacturerModel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceProfiles,
      "filter": _vm.filterConnectivityPlan,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "name",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.selcetedManufacturerModel
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.typeMAC))])], 1)];
      }
    }], null, false, 3129438056),
    model: {
      value: _vm.formItem.device_profiles,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "device_profiles", $$v);
      },
      expression: "formItem.device_profiles"
    }
  })], 1) : _c('div', {
    staticClass: "pt-4 pb-7"
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1)])], 1) : _vm._e(), _vm.datasourceType === 'actility' ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-plug",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.connectivityPlan'),
      "offset": 24
    }
  }, [!_vm.actilityOptionsIsLoading ? _c('div', {
    staticClass: "pt-4 pb-7"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.connectivityPlan'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.connectivityPlans,
      "filter": _vm.filterConnectivityPlan,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "name",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.selcetedConnectivityPlan
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.communicationType) + ": " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2025234246),
    model: {
      value: _vm.formItem.connectivity_plans,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "connectivity_plans", $$v);
      },
      expression: "formItem.connectivity_plans"
    }
  })], 1) : _c('div', {
    staticClass: "pt-4 pb-7"
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1)])], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-file-alt",
      "offset": 24
    }
  }, [_c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.addColumn')) + "\n                ")])], 1)]), _c('div', {
    staticClass: "pt-4"
  }, [_c('h5', {
    staticClass: "mb-0 headline-with-icon"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.variablesMapper')) + "\n              ")]), _c(VRow, _vm._l(_vm.headers, function (header, key) {
    return _c(VCol, {
      key: key,
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c(VAutocomplete, {
      attrs: {
        "label": header.text,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "items": _vm.commonDeviceForms,
        "filter": _vm.filterMapper,
        "append-icon": "fal fa-trash-alt",
        "auto-select-first": "",
        "item-text": "variable",
        "item-value": "map",
        "clearable": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.mappingData,
        "click:append": function ($event) {
          return _vm.deleteColumn(key);
        }
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function ({
          item
        }) {
          return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.variable))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.userInfo))])], 1)];
        }
      }], null, true),
      model: {
        value: _vm.mappedItems[header.text],
        callback: function ($$v) {
          _vm.$set(_vm.mappedItems, header.text, $$v);
        },
        expression: "mappedItems[header.text]"
      }
    })], 1);
  }), 1)], 1)])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-file-alt",
      "offset": 24
    }
  }, [_c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [!_vm.isMobile ? _c('span', [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-layer-plus"
    },
    on: {
      "click": _vm.startUpload
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.createAll')) + "\n                  ")]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.newRow
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.addNewRow')) + "\n                  ")])], 1) : _c('span', [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.createAll'),
      "prepend-icon": "fa-layer-plus"
    },
    on: {
      "click": _vm.startUpload
    }
  }), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.addNewRow'),
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.newRow
    }
  })], 1)])]), _c('div', {
    staticClass: "pt-4"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "fontb pb-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.devicesTotal')) + ":")]), _vm._v("\n                   \n                  "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v(_vm._s(_vm.contents.length))])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('span', {
    staticClass: "fontb pb-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.columns')) + ":")]), _vm._v("\n                   \n                  "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v(_vm._s(_vm.headers.length))])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('span', {
    staticClass: "fontb pb-2"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.getColor('error'),
      "title": _vm.$i18n_t('Common.delete'),
      "small": ""
    }
  }, [_vm._v("fal fa-times")]), _vm._v("\n                     \n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.error')) + ":\n                  ")], 1), _c('span', {
    staticClass: "fontb",
    attrs: {
      "color": _vm.getColor('error')
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.errorCounter) + "\n                  ")])]), _vm.errorList ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('span', [_c(VIcon, {
    staticClass: "pointer",
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.delete'),
      "small": ""
    },
    on: {
      "click": _vm.downloadList
    }
  }, [_vm._v("\n                      fal fa-arrow-circle-down\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.downloadErrorList')) + "\n                  ")], 1)]) : _vm._e(), _vm.progress ? _c(VCol, {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VProgressLinear, {
    attrs: {
      "color": _vm.color,
      "height": "20"
    },
    model: {
      value: _vm.uploadProgress,
      callback: function ($$v) {
        _vm.uploadProgress = $$v;
      },
      expression: "uploadProgress"
    }
  }, [_c('strong', [_vm._v(_vm._s(Math.ceil(_vm.uploadProgress)) + "%")])])], 1) : _vm._e()], 1), _vm.headers.length && _vm.contents.length && !_vm.progress ? _c('niota-classic-devices-upload-list', {
    key: _vm.uploadListKey,
    ref: "uploadList",
    attrs: {
      "tblHeaders": _vm.headers,
      "contents": _vm.contents,
      "progress": _vm.progress,
      "counter": _vm.counter,
      "errorCounter": _vm.errorCounter
    },
    on: {
      "deleteVariable": _vm.deleteVariable,
      "deleteRow": _vm.deleteDeviceData,
      "edit-item": _vm.editItem
    }
  }) : _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "loading": _vm.progress,
      "type": "table"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };